<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="400"
  >
    <v-form
      ref="form"
      lazy-validation
      @submit.prevent="submit"
    >
      <v-card
        class="app-card"
        style="margin-bottom: 0px;"
      >
        <v-card-title class="app-card-title">
          Cancelar Pedido
        </v-card-title>

        <v-card-text class="app-card-content">
          Você tem certeza que deseja cancelar este pedido: <strong>({{ id }})</strong>?
          <v-textarea
            v-model="reason"
            :disabled="isLoading"
            label="Motivo do cancelamento*"
            :rules="[rules.required]"
            outlined
            dense
            autofocus
            placeholder="Ex:. pedido descontinuado"
            class="mt-5"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            text
            @click="close('no_cancelled')"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            text
            :disabled="isLoading"
          >
            {{ isLoading ? "Cancelando..." : "Confirmar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script lang="js">
  import PedidoService from '@/services/pedidos.service';
  import GlobalStore from '@/store/modules/global';

  export default {
    props: {
      id: {
        type: Number,
        required: true
      },
    },
    data: () => ({
      dialog: true,
      reason: null,
      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido',
      },
      isLoading: false
    }),
    methods: {
      close(status) {
        this.dialog = false;
        this.reason = null;
        this.$refs.form.reset();
        this.$emit('close', { status });
      },
      submit() {
        const isValid = this.$refs.form.validate();
        if (isValid) {
          this.isLoading = true;
          PedidoService.cancel(this.id, this.reason).subscribe((response) => {
            GlobalStore.setSnackBar({
              show: true,
              message: 'Pedido cancelado com sucesso!',
              type: 'success'
            });
            this.isLoading = false;
            this.close('cancelled');
          }, (error) => {
            const { response: { data } } = error;
            GlobalStore.setSnackBar({
              show: true,
              message: 'Erro ao cancelar o pedido: ' + data.error,
              type: 'error'
            });
            this.isLoading = false;
          });
        }
      }
    }
  }
</script>